import { render, staticRenderFns } from "./promote.vue?vue&type=template&id=6b01601e&scoped=true"
import script from "./promote.vue?vue&type=script&lang=js"
export * from "./promote.vue?vue&type=script&lang=js"
import style0 from "./promote.vue?vue&type=style&index=0&id=6b01601e&prod&lang=css"
import style1 from "./promote.vue?vue&type=style&index=1&id=6b01601e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b01601e",
  null
  
)

export default component.exports